import {
  EQUIPMENT_STOCK_LIST, 
  EQUIPMENT_STOCK_LIST_SUCCESS, 
  EQUIPMENT_STOCK_LIST_ERROR,
  EQUIPMENT_STOCK_SEARCH_SET, 
  EQUIPMENT_STOCK_SEARCH_CHANGE, 
  EQUIPMENT_STOCK_PAGE_SET,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR, 
  EQUIPMENT_STOCK_ADD_SET,
  EQUIPMENT_STOCK_ADD_MODAL_SET,
  EQUIPMENT_STOCK_ADD,
  EQUIPMENT_STOCK_ADD_SUCCESS,
  EQUIPMENT_STOCK_ADD_ERROR,
  EQUIPMENT_STOCK_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ERROR,
  EQUIPMENT_STOCK_GET,
  EQUIPMENT_STOCK_GET_SUCCESS,
  EQUIPMENT_STOCK_GET_ERROR,
  EQUIPMENT_STOCK_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_EDIT_CHANGE,
  EQUIPMENT_STOCK_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_UPDATE,
  EQUIPMENT_STOCK_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_UPDATE_ERROR,
  EQUIPMENT_STOCK_VIEW_TAB_SET,
  EQUIPMENT_STOCK_UPLOAD_SET,
  EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS,
  EQUIPMENT_STOCK_UPLOAD_SET_ERROR,
  EQUIPMENT_STOCK_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 1000
    }
  },
  add: {
      data: {
        new:{ id_assessment: null, assessment: null, id_assessment_project: null, assessment_project: null, start_date: null, end_date: null, equipment_stock: null }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      assessment: false,
      assessment_project: false
    },
    value:{
      assessment: false,
      assessment_project: false
    },
    assessment:{
      loading: true,
      list:[],
      message: ''
    },
    assessment_project:{
      loading: true,
      list:[],
      message: ''
    },
    supervision_report:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  get: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EQUIPMENT_STOCK_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EQUIPMENT_STOCK_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EQUIPMENT_STOCK_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EQUIPMENT_STOCK_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EQUIPMENT_STOCK_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EQUIPMENT_STOCK_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment:{
            ...state.search.assessment,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment_project:{
            ...state.search.assessment_project,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_project:{
            ...state.search.assessment_project,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_project:{
            ...state.search.assessment_project,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          supervision_report:{
            ...state.search.supervision_report,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          supervision_report:{
            ...state.search.supervision_report,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          supervision_report:{
            ...state.search.supervision_report,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EQUIPMENT_STOCK_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_assessment: null, assessment: null, start_date: null, end_date: null, equipment_stock: null}
          },
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EQUIPMENT_STOCK_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EQUIPMENT_STOCK_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EQUIPMENT_STOCK_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    
      case EQUIPMENT_STOCK_GET:
        return {
          ...state,
          get: {
            ...state.get,
            loading: true
          }
        }
      case EQUIPMENT_STOCK_GET_SUCCESS:
        return {
          ...state,
          get: {
            ...state.get,
            loading: false,
            data: action.payload
          },
          edit: {
            ...state.edit,
            loading: false,
            data: {
              new: action.payload,
              old: action.payload
            }
          }
        }
      case EQUIPMENT_STOCK_GET_ERROR:
        return {
          ...state,
          get: {
            ...state.get,
            loading: false,
            data: []
          }
        }
    case EQUIPMENT_STOCK_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EQUIPMENT_STOCK_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case EQUIPMENT_STOCK_UPLOAD_SET:
      return { ...state };
    case EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case EQUIPMENT_STOCK_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case EQUIPMENT_STOCK_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};